import { combineReducers } from "redux";

import list from "./List/reducer";
import create from "./Create/reducer";
import edit from "./Edit/reducer";

const rolesReducer = combineReducers({
  list,
  create,
  edit,
});

export default rolesReducer;
